import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet, UrlSegment } from '@angular/router';
import { HeaderComponent } from "./components/header/header.component";
import { Subscription } from 'rxjs';
import { CommonModule, ViewportScroller } from '@angular/common';
import { gsap, Expo, Quad } from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { BookingPopupComponent } from "./components/booking-popup/booking-popup.component";
import { FooterComponent } from "./components/footer/footer.component";
import { AuthService } from './services/Auth/auth.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { GTMService } from './services/gtm.service';

@Component({
    selector: 'app-root',
    imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    BookingPopupComponent,
    FooterComponent
],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'Lionsgate Repertory';
    currentUrlObservable: string = '';
    private urlSubscription: Subscription | undefined;
    public isMobile: boolean = false

    public isHeaderHidden: boolean = false

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService,
        private breakpointObserver: BreakpointObserver,
        public gtmService: GTMService,
        private viewport: ViewportScroller
    ) {
        gsap.registerPlugin(ScrollToPlugin);

         breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });

        this.router.events.subscribe((e) => {
            if (e instanceof NavigationEnd) {
                this.viewport.scrollToPosition([0, 0]);
                document.body.scrollTop = 0;
                // gsap.to(window, { duration: 0, scrollTo: 0 });
                // setTimeout(() => {
                //     console.log('Scroll top')
                //     // gsap.to(window, { duration: 0, scrollTo: 0 });
                //     // gsap.to(window, 0.01, { scrollTo: 0 });
                //     this.viewport.scrollToPosition([0, 0]);
                // }, 2000);
            }
        });

        this.urlSubscription = this.activatedRoute.url.subscribe((segments: UrlSegment[]) => {
            this.currentUrlObservable = segments.map(segment => segment.path).join('/');

            if (window.location.href.includes('/login')) {
                this.isHeaderHidden = true
            }
            else {
                this.isHeaderHidden = false
            }
        });
    }
}
